(() => {
  const handles = new Set(['diamond-tennis-chain', 'diamond-tennis-bracelet', '3mm-evil-eye-diamond-bracelet', '6mm-evil-eye-diamond-bracelet']);
  const colourOf = value => /rose/i.test(value) ? 'Rose Gold' : 'White Gold';
  const tierOf = value => /silver/i.test(value) ? 'silver' : /natural/i.test(value) ? 'natural' : 'lab';
  function init(root) {
    if ((!handles.has(root.dataset.productHandle) && !['16019221971328', '16019223544192'].includes(root.dataset.productId)) || root.dataset.ilColourOptionsReady) return;
    root.dataset.ilColourOptionsReady = 'true';
    const product = JSON.parse(root.querySelector('[data-product-json]').textContent);
    const wrappers = [...root.querySelectorAll('[data-option-position]')];
    const materialIndex = product.options.findIndex(option => /metal/i.test(typeof option === 'string' ? option : option.name));
    const colourIndex = product.options.findIndex(option => /colou?r/i.test(typeof option === 'string' ? option : option.name));
    const material = wrappers.find(wrapper => Number(wrapper.dataset.optionPosition) === materialIndex + 1);
    if (!material) return;
    const inputs = [...material.querySelectorAll('input[type="radio"]')];
    const combined = colourIndex < 0;
    let virtual;
    let colour = combined ? colourOf(inputs.find(input => input.checked)?.value) : '';
    if (combined) {
      virtual = document.createElement('div');
      virtual.className = 'selector-wrapper il-finish-selector';
      const fieldset = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.className = 'radio__legend';
      legend.textContent = 'Colour';
      const buttons = document.createElement('div');
      buttons.className = 'radio__buttons';
      ['White Gold', 'Rose Gold'].forEach(value => {
        const wrapper = document.createElement('span');
        wrapper.className = 'radio__button';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'il-finish-' + root.dataset.productId;
        input.id = input.name + '-' + value.replace(' ', '-');
        input.value = value;
        input.checked = value === colour;
        const label = document.createElement('label');
        label.htmlFor = input.id;
        label.textContent = value;
        wrapper.append(input, label);
        buttons.append(wrapper);
      });
      fieldset.append(legend, buttons);
      virtual.append(fieldset);
      material.before(virtual);
      virtual.addEventListener('change', event => {
        event.stopPropagation();
        const selected = inputs.find(input => input.checked);
        colour = event.target.value;
        const next = inputs.find(input => colourOf(input.value) === colour && tierOf(input.value) === tierOf(selected?.value));
        if (next) {
          next.checked = true;
          next.dispatchEvent(new Event('change', {bubbles: true}));
        }
        update();
      });
    }
    const editorial = document.querySelector('.il-editorial[data-product-id="' + root.dataset.productId + '"]');
    const originalImages = [...(editorial?.querySelectorAll('.il-editorial__media img') || [])].map(img => ({img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), alt: img.alt}));
    function update() {
      if (combined) colour = colourOf(inputs.find(input => input.checked)?.value);
      else colour = wrappers.find(wrapper => Number(wrapper.dataset.optionPosition) === colourIndex + 1)?.querySelector('input:checked')?.value || 'Rose Gold';
      virtual?.querySelectorAll('input').forEach(input => { input.checked = input.value === colour; });
      inputs.forEach(input => {
        const valid = combined ? colourOf(input.value) === colour : product.variants.some(variant => variant.options[colourIndex] === colour && variant.options[materialIndex] === input.value);
        const wrapper = input.closest('.radio__button');
        wrapper.hidden = !valid;
        wrapper.toggleAttribute('data-il-option-hidden', !valid);
        const label = wrapper.querySelector('label span') || wrapper.querySelector('label');
        const tier = tierOf(input.value);
        label.textContent = tier === 'silver' ? (colour === 'Rose Gold' ? 'Rose Gold-Plated 925 Silver + Lab-Grown Diamonds' : '925 Silver + Lab-Grown Diamonds') : '14k ' + colour + ' + ' + (tier === 'natural' ? 'Natural Diamonds' : 'Lab-Grown Diamonds');
      });
      const hero = product.variants.find(variant => combined ? colourOf(variant.options[materialIndex]) === colour : variant.options[colourIndex] === colour)?.featured_image?.src;
      const editorialMap = {"diamond-tennis-chain": {"Rose": ["https://cdn.shopify.com/s/files/1/2035/0603/files/9_a89fbe65-0c65-479b-99aa-d1b577ad8181.png?v=1761413645", "https://cdn.shopify.com/s/files/1/2035/0603/files/01-Tennis-Chain-Rose-Gold-2400x3000.jpg?v=1793040825"], "White": ["https://cdn.shopify.com/s/files/1/2035/0603/files/tc2.png?v=1761409690", "https://cdn.shopify.com/s/files/1/2035/0603/files/ProductPagePics_8_3abe9777-b54a-4448-88a6-52407a43af07.png?v=1761409687"]}, "diamond-tennis-bracelet": {"Rose": ["https://cdn.shopify.com/s/files/1/2035/0603/files/DSC04244.jpg?v=1761405396", "https://cdn.shopify.com/s/files/1/2035/0603/files/DSC03866.jpg?v=1761405395"], "White": ["https://cdn.shopify.com/s/files/1/2035/0603/files/0S6A1126.png?v=1761410848", "https://cdn.shopify.com/s/files/1/2035/0603/files/SPPRODUCTPICS4X5_2.png?v=1761410845"]}};
      originalImages.forEach(({img, src, srcset, alt}, index) => {
        const chosen = editorialMap[root.dataset.productHandle]?.[colour === 'Rose Gold' ? 'Rose' : 'White']?.[index];
        if (chosen) {
          img.removeAttribute('srcset');
          img.src = chosen;
          img.alt = product.title + ' — ' + colour + (index ? ' design detail' : ' styling');
          return;
        }
        const match = alt.match(/colour:(rose|white)/i);
        if (match && colourOf(match[1]) !== colour && hero) {
          img.removeAttribute('srcset');
          img.src = hero;
          img.alt = product.title + ' — ' + colour;
        } else {
          img.src = src;
          if (srcset) img.setAttribute('srcset', srcset);
          img.alt = alt;
        }
      });
    }
    root.addEventListener('change', update);
    root.addEventListener('theme:variant:change', update);
    update();
  }
  const boot = () => document.querySelectorAll('.il-pdp').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
